import * as React from 'react';
import { FC } from 'react';

import { Icon } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { ServiceMode } from 'state/service-mode';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

import {
  ReminderSubtitle,
  ReminderTitle,
  TextWrapper,
  Wrapper,
} from './cash-payment-reminder.styled';

interface ICashPaymentReminderProps {
  serviceMode: ServiceMode;
}

/**
 * Display a short message to remind customers to pay for their order in cash
 */
const CashPaymentReminder: FC<React.PropsWithChildren<ICashPaymentReminderProps>> = ({
  serviceMode,
}) => {
  const { formatMessage } = useIntl();

  const subtitleKey =
    serviceMode === ServiceMode.DELIVERY ? 'uponOrderDelivery' : 'uponOrderPickup';

  return (
    <Wrapper testID="cash-payment-message">
      <Icon variant="error" width="24px" {...hiddenAccessibilityPlatformProps} />
      <TextWrapper>
        <ReminderTitle>{formatMessage({ id: 'pleaseHaveYourCashReady' })}</ReminderTitle>
        <ReminderSubtitle>{formatMessage({ id: subtitleKey })}</ReminderSubtitle>
      </TextWrapper>
    </Wrapper>
  );
};

export default CashPaymentReminder;
